import { render } from "./SupplierSelection.vue?vue&type=template&id=39931414&scoped=true"
import script from "./SupplierSelection.vue?vue&type=script&lang=ts"
export * from "./SupplierSelection.vue?vue&type=script&lang=ts"

import "./SupplierSelection.vue?vue&type=style&index=0&id=39931414&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-39931414"

export default script